import { Label, Select } from 'flowbite-react'
import {
  GROUPING_ALL_IN_ONE,
  GROUPING_BY_GAME,
  type Grouping,
} from '@constants/exports'

interface GroupingSelectProps {
  value: Grouping
  onChange: (next: Grouping) => void
}

function GroupingSelect({ value, onChange }: GroupingSelectProps) {
  return (
    <div>
      <Label
        className="mb-2 block text-sm font-semibold text-slate-950 dark:text-slate-100"
        htmlFor="export-grouping"
      >
        Группировка
      </Label>
      <Select
        id="export-grouping"
        value={String(value)}
        onChange={(event) => onChange(Number(event.target.value) as Grouping)}
      >
        <option value={GROUPING_ALL_IN_ONE}>Все в одном</option>
        <option value={GROUPING_BY_GAME}>Каждая игра отдельно</option>
      </Select>
    </div>
  )
}

export default GroupingSelect
